<ng-content select="soft-chip"></ng-content>
